/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/window.d.ts" />

/**
 * Probe service
 */
namespace Application.Services {
    'use strict';

    import Probe = Models.Probe;
    import IHalList = Models.IHalList;
    import HalConverter = Models.HalConverter;
    import IHalElement = Models.IHalElement;
    import IPaginatedList = Models.IPaginatedList;

    /**
     * ProbeService
     */
    export class ProbeService {
        public static $name: string = "probeService";
        public static $inject: string[] = ['networkService', 'backendService'];

        private networkService: NetworkService;
        private backendService: BackendService;
        private backendBaseUrl: string = window.backendUrl;
        // private servicePath: string = 'probes/';
        private servicePath: string = '';
        private backendUrl: string = this.backendBaseUrl + this.servicePath + 'probes';

        constructor(networkService: NetworkService, backendService: BackendService) {
            this.networkService = networkService;
            this.backendService = backendService;
        }

        public getFlexoProbe(callback: (result: Probe) => void): void {
            // flexo probe is id 1
            this.getProbePromiseById(1).then(
                (element: Probe) => {
                    this.burnishProbe(element);
                    callback(element);
                }
            ).catch(() => {
                callback(undefined);
            });
        }

        public getProbeById(probeId: number, callback: (result: Probe) => void): void {
            this.getProbePromiseById(probeId).then(
                (element: Probe) => {
                    this.burnishProbe(element);
                    callback(element);
                }
            ).catch(() => {
                callback(undefined);
            });
        }

        public sendIntinorEvent(srtParams: any): ng.IPromise<any> {
            return this.backendService.post(this.backendBaseUrl+ "tsprobe/probeIntinor", {
                "passphrase": srtParams.passphrase,
                "port": srtParams.port,
                "ip": srtParams.ip,
                "mode": "caller",
                "blockIndex": srtParams.blockIndex - 1,
                "startProbe": srtParams.startProbe,
                "sinkBlockName": srtParams.sinkBlockName,
                "device": srtParams.device,
            });
        }

        public getAllPaginatedProbesPromise(page?: number, size?: number, sort?: String): ng.IPromise<IPaginatedList<Probe>> {
            let url: string = this.backendUrl + '?';
            url = page ? url += '&page=' + page : url;
            url = size ? url += '&size=' + size : url;
            url = sort ? url += '&sort=' + sort : url;
            return this.backendService
                .get(url, true)
                .then((result: ng.IHttpPromiseCallbackArg<IHalList<Probe>>) => {
                    let convertedList: IPaginatedList<Probe> = HalConverter.convertPaginatedList(result.data, Probe.Empty);
                    convertedList.elements.forEach((element: Probe) => {
                        this.burnishProbe(element);
                    });
                    return convertedList;
                });
        }

        public getAllProbesPromise(): ng.IPromise<Probe[]> {
            return this.backendService
                .get(this.backendUrl + "/filtered?size=5000")
                .then((result: ng.IHttpPromiseCallbackArg<IHalList<Probe>>) => {
                    let halElement: IHalList<Probe> = result.data;
                    let converted: Probe[] = HalConverter.convertList(halElement, Probe.Empty);
                    converted.forEach((element: Probe) => {
                            this.burnishProbe(element);
                    });
                    return converted;
                });
        }

        public saveProbe(probe: Application.Models.IProbe): ng.IPromise<Models.IProbe> {
            if (!probe.href || probe.href === undefined || probe.href === '') {
                return this.createProbe(probe);
            } else {
                return this.updateProbe(probe);
            }
        }

        public createProbe(probe: Application.Models.IProbe): ng.IPromise<Models.IProbe> {
            return this.backendService
                .post(this.backendUrl, {
                    name: probe.name,
                    creationDate: probe.creationDate,
                    networkInterfaces: probe.networkInterfaces,
                    x: probe.x,
                    y: probe.y,
                })
                .then((result: ng.IHttpPromiseCallbackArg<Models.IHalElement<Models.IProbe>>) => {
                    let halElement: IHalElement<Probe> = result.data;
                    let converted: Probe = HalConverter.convertElement(halElement, Models.Probe.Empty);
                    return this.burnishProbe(converted);
                 });
        }

        public updateProbe(probe: Application.Models.IProbe): ng.IPromise<Models.IProbe> {
            return this.backendService
                .put(probe.href, {
                    name: probe.name,
                    creationDate: probe.creationDate,
                    networkInterfaces: probe.networkInterfaces,
                    /* tslint:disable */
                    x: probe.x ? probe.x : null,
                    y: probe.y ? probe.y : null,
                    /* tslint:enable */
                })
                .then ((result: ng.IHttpPromiseCallbackArg<Models.IHalElement<Models.IProbe>>) => {
                    let halElement: IHalElement<Probe> = result.data;
                    let converted: Probe = HalConverter.convertElement(halElement, Probe.Empty);
                    return this.burnishProbe(converted);
                 }
            );
        }

        public deleteProbe(probe: Application.Models.IProbe): ng.IPromise<boolean> {
            return this.backendService.delete(probe.href);
        }

        public addPositionToProbe(href: string, x: number, y: number): ng.IPromise<Probe> {
            return this.getProbePromise(href).then(
                (probe: Probe) => {
                    probe.x = x;
                    probe.y = y;
                    return this.updateProbe(probe);
                 }
            );
        }

        public getProbePromise(href: string): ng.IPromise<Probe> {
            return this.backendService
                .get(href)
                .then((data: ng.IHttpPromiseCallbackArg<IHalElement<Probe>>) => {
                    let halElement: IHalElement<Probe> = data.data;
                    let converted: Probe = HalConverter.convertElement(halElement, Probe.Empty);
                    return this.burnishProbe(converted);
                });
        }

        public getProbePromiseById(probeId: number): ng.IPromise<Probe> {
            return this.backendService
                .get(this.backendUrl + "/" + probeId)
                .then((data: ng.IHttpPromiseCallbackArg<IHalElement<Probe>>) => {
                    let halElement: IHalElement<Probe> = data.data;
                    let converted: Probe = HalConverter.convertElement(halElement, Probe.Empty);
                    return this.burnishProbe(converted);
                });
        }


        private burnishProbe(element: Probe): Probe {
            // placeholder, nothing to do now
            return element;
        }
    }
}